import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faEnvelopeSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { MessageRequest } from "../../../store/messages/types";
import ContactUsForm from "./ContactUsForm";

export const ContactUs: React.FC<{ onSubmit(messageRequest: MessageRequest): void }> = (props: any) => {
    const [showContactNumber, setShowContactNumber] = useState(false);

    const displayContactNumber = () => {
        setShowContactNumber(true);
    }

    return (
        <React.Fragment>
            <section className="bg-dark py-0" id="contact-us">
                <div className="container py-6">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 text-center order-2 order-lg-1" data-aos="fade-up">
                            <ContactUsForm onSubmit={props.onSubmit} />
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="px-5 py-4">
                                <h1 className="text-white">Contact Us</h1>
                                <h3 className="text-white pt-5">We offer competitve pricing to suit your needs.</h3>
                                <p className="lead text-white pt-5">
                                    {showContactNumber ? <a className="text-white" href="tel:+61413250519">+61 413 250 519</a> : <a href="javascript:void(0);" onClick={displayContactNumber} className="text-white">+61 413 250 XXX <small>(click to reveal)</small></a>}
                                </p>
                                <div style={{ fontSize: "3rem" }}>
                                    <a className="icon-list-social-link text-white large" href="https://www.facebook.com/Iman-Logistics-1812552819045918">
                                        <FontAwesomeIcon icon={faFacebookSquare} />
                                    </a>
                                    <a className="icon-list-social-link text-white pl-3" href="mailto:imanlogistics5@gmail.com">
                                        <FontAwesomeIcon icon={faEnvelopeSquare} />
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default ContactUs;
